import React, { Component } from 'react';
import Navbar from './mycomponents/navbar';
import ViewMyGroupBody from './mycomponents/viewmygroupbody';
import PalmeeupIcon from './mycomponents/palmeeupbuttonicon';

class ViewMyGroup extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
            <Navbar/>
            
            <ViewMyGroupBody />
            <PalmeeupIcon/>
                </React.Fragment>
        );
    }
}
 
export default ViewMyGroup;